import { Subscription, ReplaySubject, Subject, Observable, fromEvent, of, } from 'rxjs';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewChild, AfterViewInit, Inject, ElementRef, Optional, } from '@angular/core';
import { Router, ActivatedRoute, RouterOutlet } from '@angular/router';
import { ApiService } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
declare var $: any;
import { environment } from '../../../environments/environment';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { datePickerMinDate } from '../../shared/constants';
import { catchError, debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { NgxFileDropEntry, FileSystemFileEntry } from 'ngx-file-drop';
import { inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import Swal from 'sweetalert2';
import { slideInAnimation } from '../../animations/route-animation';
import { addMonths } from 'date-fns';
import { DomSanitizer } from '@angular/platform-browser';
import * as FileSaver from 'file-saver';
import { HttpClient } from '@angular/common/http';
import { NavbarComponent } from '../../navbar/navbar.component';

@Component({
	selector: 'app-prescription',
	templateUrl: './prescription.component.html',
	styleUrl: './prescription.component.scss',
	animations: [
		trigger('fadeInOut', [
			state('void', style({
				opacity: 0
			})),
			transition(':enter, :leave', [
				animate(500)
			])
		]),
		slideInAnimation
	]
})
export class PrescriptionComponent implements OnInit {
	breadcrumbList: any[] = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		{
			path: "/app/list-appointment",
			name: "Appointment List"
		}
	];
	uId: any = null;
	caseDetails: any = {};
	pageLoading1 = false;
	pagetitle: string = "Prescription";
	File_Storage_URL = environment.File_Storage_URL;
	activeTab: any = 0;
	minDate = datePickerMinDate;
	doctorList: any = [];

	public medArray: Array<any> = [];
	public medArrayTemp: Array<any> = [];
	saveMedLoader = false;
	showMedHistory = true;
	printPrescArray: any = [];
	casePrescPdfList: any = [];
	prescriptionPara: any = {
		prescUserType: 'Candidate',
		chief_complaint: null,
		prescDoctor: null
	}
	prescPdfLoader = false;
	mealsList: any = ["Before", "After"];
	medicineMaster: any[] = [];
	medLoading: any = null;
	medLoadingIndex: number | null = null;
	private searchTermsMed = new Subject<string>();

	public testArray: Array<any> = [];
	public testArrayTemp: Array<any> = [];
	saveTestLoader = false;
	showTestHistory = true;
	printTestArray: any = [];
	caseTestPdfList: any = [];
	testPara: any = {
		prescUserType: 'Candidate',
		chief_complaint: null,
		prescDoctor: null
	}
	testPdfLoader = false;
	testMaster: any[] = [];
	testLoading: any = null;
	testLoadingIndex: number | null = null;
	private searchTermsTest = new Subject<string>();

	constructor(private apiService: ApiService, private activeRoute: ActivatedRoute, private toastr: ToastrService, @Optional() @Inject(NavbarComponent) public navbar: NavbarComponent) {
		this.apiService.doctorData$.subscribe((doctors: any) => {
			if (doctors) {
				this.getAllDoctors();
			}
		})
	}
	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.uId = routeParams["uId"];
			this.breadcrumbList.push({ path: "/app/appt-details/no/" + this.uId + "/empty", name: "Appointment Details" });
			this.breadcrumbList.push({ path: "/app/prescription/" + this.uId, name: this.pagetitle });
			this.getCaseDetails();
			/* this.getAllDoctors(); */

			this.getCaseMedicines();
			this.casePrescPdfHistory();
			this.searchTermsMed.pipe(debounceTime(500), distinctUntilChanged(), tap(() => this.medLoading = this.medLoadingIndex), switchMap(term => this.apiService.getMedicine({ draw: 1, start: 0, length: 50, searchVal: term }))).subscribe({
				next: (res: any) => {
					this.medicineMaster = res.data.map((med) => med.name);
					this.medLoading = null;
				}, error: () => {
					this.medLoading = null;
				}
			});

			this.getCaseTests();
			this.caseTestPdfHistory();
			this.searchTermsTest.pipe(debounceTime(500), distinctUntilChanged(), tap(() => this.testLoading = this.testLoadingIndex), switchMap(term => this.apiService.getLabTest({ draw: 1, start: 0, length: 50, searchVal: term }))).subscribe({
				next: (res: any) => {
					this.testMaster = res.data.map((test) => test.name);
					this.testLoading = null;
				}, error: () => {
					this.testLoading = null;
				}
			});
		});
	}

	getTabClass(num: any) {
		if (this.activeTab == num) {
			return "active";
		} else {
			return "";
		}
	}

	getTabPaneClass(num: any) {
		if (this.activeTab == num) {
			return "tab-pane active";
		} else {
			return "tab-pane";
		}
	}

	setActiveTab(num: any) {
		this.activeTab = num;
		if (num == 0) {
		} else if (num == 1) {
		} else if (num == 2) { }
	}

	getCaseDetails() {
		this.pageLoading1 = true;
		this.apiService.getUpdateCaseDetails({ id: this.uId }).subscribe({
			next: (data: any) => {
				this.pageLoading1 = false;
				this.caseDetails = data;
			}, error: (error) => {
				this.pageLoading1 = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	getAllDoctors() {
		/* this.apiService.getDoctorList({}).subscribe({
			next: (data: any) => {
				this.doctorList = data.data;
			}, error: (error) => {
				this.doctorList = [];
			},
		}); */
		this.doctorList = this.navbar.filterDoctors();
	}

	getDateStringFromDateYMD(date: any) {
		if (date == "" || date == null || date == undefined) {
			return "";
		}
		var month = date.getMonth() + 1;
		var day = date.getDate();
		var year = date.getFullYear();
		var dayStr = day < 10 ? '0' + day : day;
		var monthStr = month < 10 ? '0' + month : month;
		var fromStr = year + "/" + monthStr + "/" + dayStr;
		return fromStr;
	}

	getDateStringFromDateDMY(date: any) {
		if (date == "" || date == null || date == undefined) {
			return "";
		}
		var month = date.getMonth() + 1;
		var day = date.getDate();
		var year = date.getFullYear();
		var dayStr = day < 10 ? '0' + day : day;
		var monthStr = month < 10 ? '0' + month : month;
		var fromStr = dayStr + "/" + monthStr + "/" + year;
		return fromStr;
	}

	checkZero(data: any) {
		if (data != undefined && data.toString().length == 1) {
			data = "0" + data;
		}
		return data;
	}

	getUserName() {
		let name = "";
		try {
			name = this.navbar.user?.first_name + " " + this.navbar.user?.last_name;
			return name;
		} catch (error) {
			return name;
		}
	}

	getFileName(filepath: string) {
		try {
			return filepath.split("/").reverse()[0];
		} catch (error) {
			return ""
		}
	}

	selectElementContents(id: any) {
		var el: any = document.getElementById(id);
		var body: any = document.body;
		var range: any;
		var sel: any;
		if (document.createRange && window.getSelection) {
			range = document.createRange();
			sel = window.getSelection();
			sel.removeAllRanges();
			try {
				range.selectNodeContents(el);
				sel.addRange(range);
			} catch (e) {
				range.selectNode(el);
				sel.addRange(range);
			}
			document.execCommand('copy');
			sel.removeAllRanges();
			this.toastr.success("Copied to clipboard", 'Success', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
		} else if ($(body).createTextRange) {
			range = $(body).createTextRange();
			range.moveToElementText(el);
			range.select();
			this.toastr.error("Unable to copy", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
		}
	}

	/* Medicines */

	getCaseMedicines() {
		this.apiService.getPrescription({ id: this.uId, flag: "meds" }).subscribe({
			next: (data: any) => {
				try {
					this.medArray = data ? JSON.parse(JSON.stringify(data)) : [];
				} catch (error) {
					this.medArray = [];
				}
				try {
					this.medArrayTemp = data ? JSON.parse(JSON.stringify(data)) : [];
				} catch (error) {
					this.medArrayTemp = [];
				}
				for (let i = 0; i < this.medArray.length; i++) {
					try {
						this.medArray[i].medDate = new Date(this.medArray[i].medDate);
						if (this.medArray[i].medDate instanceof Date && !isNaN(this.medArray[i].medDate)) {

						} else {
							this.medArray[i].medDate = null;
						}
					} catch (error) {
						this.medArray[i].medDate = null;
					}
					this.medArray[i].isSaved = true;
					/* this.medicineMasterListArray.push([]); */
					try {
						if (!isNaN(this.medArray[i].noOfDays) && this.medArray[i].medDate) {
							let medDate: any = new Date(this.medArray[i].medDate);
							medDate.setHours(0, 0, 0, 0);
							let noOfDays: any = parseInt(this.medArray[i].noOfDays);
							const today: any = new Date();
							today.setHours(0, 0, 0, 0);
							const diffTime: any = Math.abs(today - medDate);
							const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
							if (diffDays >= noOfDays && this.medArray[i].status == "Started") {
								this.medArray[i].status = "Completed";
							}
						}
					} catch (error) { }
					this.medArray[i].isCheckedForMail = true;
					if (this.medArray[i].status == "Stopped" || this.medArray[i].status == "Completed") {
						this.medArray[i].showCheckboxForMail = false;
					} else {
						this.medArray[i].showCheckboxForMail = true;
					}
				}
			}, error: (error) => {
				this.medArray = [];
				this.medArrayTemp = [];
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	medSection() {
		this.showMedHistory = !this.showMedHistory;
		this.printPrescArray = [];
	}

	casePrescPdfHistory() {
		this.apiService.casePrescriptionList({ id: this.uId, flag: "prescription" }).subscribe({
			next: data => {
				this.casePrescPdfList = data;
			}, error: (error) => {
				this.casePrescPdfList = [];
			}
		});
	}

	copyMedicinesToClipBoard(num: number) {
		var tableId = "medicineTempTableToCopy" + num;
		let tblStr = '<ul id="' + tableId + '">';
		for (let i = 0; i < this.medArray.length; i++) {
			tblStr += '<li>';
			tblStr += this.medArray[i].medDate ? this.getDateStringFromDateDMY(new Date(this.medArray[i].medDate)) : "";
			tblStr += ' - ';
			tblStr += this.medArray[i].name;
			tblStr += ' - ';
			tblStr += this.medArray[i].qty;
			tblStr += '-';
			tblStr += this.getFrequencyText(this.medArray[i]);
			tblStr += ' - ';
			tblStr += this.medArray[i].meals;
			tblStr += " meal";
			if (this.medArray[i].noOfDays != undefined && this.medArray[i].noOfDays != null && this.medArray[i].noOfDays !== "") {
				tblStr += ' - ';
				tblStr += this.medArray[i].noOfDays;
				tblStr += ' days';
			}
			tblStr += ' - ';
			tblStr += this.medArray[i].status;
			tblStr += '-';
			tblStr += this.medArray[i].notes ? ' - ' + this.medArray[i].notes : "";
			tblStr += '</li>';
		}
		tblStr += '</ul>';
		$("#medicineTempTableContainerForCopy" + num).html(tblStr);
		this.selectElementContents(tableId);
		$("#medicineTempTableContainerForCopy" + num).html("");
	}

	getFrequencyText(obj: any) {
		let textArr: any = [];
		if (obj.morning) {
			textArr.push("Morning");
		}
		if (obj.afternoon) {
			textArr.push("Afternoon");
		}
		if (obj.evening) {
			textArr.push("Evening");
		}
		if (obj.sos) {
			textArr.push("SOS");
		}
		return textArr.length ? textArr.join(", ") : "-";
	}

	loadMedsPdf() {
		if (!this.prescriptionPara.prescDoctor) {
			this.toastr.error("Please select doctor.", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		let address = '';
		let mobOrEmail = '';
		let cand_dob: any = "";
		if (this.caseDetails.dob) {
			try {
				let curDate = new Date();
				let candDOB = new Date(this.caseDetails.dob.split("-").reverse().join("/"));
				let candDOBYear = candDOB.getFullYear();
				let curYear = curDate.getFullYear();
				cand_dob = curYear - candDOBYear;
			} catch (error) {
				cand_dob = "";
			}
		}
		if (this.prescriptionPara.prescUserType == 'Candidate') {
			address = this.caseDetails.address || '-';
			mobOrEmail = this.caseDetails.email || this.caseDetails.tel_no || "-";
		} else {
			address = this.caseDetails.vessel || '-';
			/* mobOrEmail = this.caseDetails.vesselEmail || "-"; */
			mobOrEmail = this.caseDetails.vessel || "-";
		}
		let prescDetails: any = {};
		prescDetails.candName = this.caseDetails.f_name + " " + this.caseDetails.l_name;
		prescDetails.caseId = this.caseDetails.case_id;
		prescDetails.id = this.uId;
		prescDetails.gender = this.caseDetails.gender;
		prescDetails.prescribeBy = this.prescriptionPara.prescDoctor ? this.prescriptionPara.prescDoctor.name : "";
		prescDetails.address = address;
		prescDetails.mobOrEmail = mobOrEmail;
		prescDetails.chief_complaint = this.prescriptionPara.chief_complaint;
		prescDetails.cand_dob = cand_dob.toString();
		prescDetails.doctor = this.prescriptionPara.prescDoctor ? this.prescriptionPara.prescDoctor.id : null;
		let finalMeds: any = [];
		if (this.printPrescArray.length > 0) {
			for (let i = 0; i < this.printPrescArray.length; i++) {
				finalMeds.push({
					name: this.printPrescArray[i]["name"],
					qty: this.printPrescArray[i]["qty"] != undefined ? this.printPrescArray[i]["qty"] : "",
					meals: this.printPrescArray[i]["meals"] != undefined ? this.printPrescArray[i]["meals"] : "",
					noOfDays: this.printPrescArray[i]["noOfDays"],
					status: this.printPrescArray[i]["status"] != undefined ? this.printPrescArray[i]["status"] : "",
					notes: this.printPrescArray[i]["notes"] != undefined ? this.printPrescArray[i]["notes"] : "",
					morning: this.printPrescArray[i]["morning"] != undefined ? this.printPrescArray[i]["morning"] : false,
					afternoon: this.printPrescArray[i]["afternoon"] != undefined ? this.printPrescArray[i]["afternoon"] : false,
					evening: this.printPrescArray[i]["evening"] != undefined ? this.printPrescArray[i]["evening"] : false,
					sos: this.printPrescArray[i]["sos"] != undefined ? this.printPrescArray[i]["sos"] : false,
					medDate: this.getDateStringFromDateDMY(this.printPrescArray[i]["medDate"]),
				})
			}
		}
		prescDetails.prescArr = finalMeds;
		this.prescPdfLoader = true;
		this.apiService.getPrescriptionPdf(prescDetails).subscribe({
			next: (data: any) => {
				let pdfData: any = data["body"];
				const blob = new Blob([pdfData], { type: 'application/pdf' });
				var today = new Date();
				var day = today.getDate() + "";
				var month = (today.getMonth() + 1) + "";
				var year = today.getFullYear() + "";
				var hour = today.getHours() + "";
				var minutes = today.getMinutes() + "";
				var seconds = today.getSeconds() + "";

				day = this.checkZero(day);
				month = this.checkZero(month);
				hour = this.checkZero(hour);
				minutes = this.checkZero(minutes);
				seconds = this.checkZero(seconds);
				let fileName = day + "-" + month + "-" + year;
				FileSaver.saveAs(blob, "Prescription_" + fileName + "_" + this.caseDetails.case_id + ".pdf");
				this.prescPdfLoader = false;
				this.clearPrescArray();
				this.casePrescPdfHistory();
			}, error: (error) => {
				this.toastr.error("Unable to generate pdf.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.prescPdfLoader = false;
			}
		});
	}

	clearPrescArray() {
		this.printPrescArray = [];
		this.prescriptionPara.chief_complaint = null;
		this.prescriptionPara.prescDoctor = null;
		this.prescriptionPara.prescUserType = "Candidate";
		this.medArray.forEach((val, key) => {
			setTimeout(() => {
				val.isChecked = false;
			}, 100);
		})
	}

	checkMedicine(data: any) {
		if (data.isChecked) {
			this.printPrescArray.push(data);
		} else {
			this.printPrescArray.forEach((val: any, key: any) => {
				if (val.name === data.name) {
					this.printPrescArray.splice(key, 1);
				}
			})
		}
	}

	removeMedicine(index: any) {
		this.medArray.splice(index, 1);
		this.medArrayTemp.splice(index, 1);
	}

	AddNewMedicine() {
		this.medArray.push(this.getNewMedAttr());
		this.medArrayTemp.push(this.getNewMedAttr());
	}

	getNewMedAttr() {
		return { name: null, noOfDays: null, status: "Started", medDate: new Date() };
	}

	saveMedicines() {
		for (let i = 0; i < this.medArray.length; i++) {
			let val = this.medArray[i];
			if (val.name == undefined || val.medDate == undefined || val.medDate == null || val.name.length == 0 /* || !val.noOfDays || (!val.morning && !val.afternoon && !val.evening && !val.sos) */) {
				this.toastr.error("Required Fields", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				return;
			}
			if (val.noOfDays != undefined && val.noOfDays != null && val.noOfDays != "") {
				if (isNaN(val.noOfDays)) {
					this.toastr.error("Required numbers only in No. of days", 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
					return;
				} else if (parseFloat(val.noOfDays) < 0) {
					this.toastr.error("Number of days should be positive", 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
					return;
				}
			}
			if (val.morning || val.afternoon || val.evening) {
				if (val.noOfDays == undefined || val.noOfDays == null || val.noOfDays === "") {
					this.toastr.error("No. of days required", 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
					return;
				}
			}
		}
		let finalMeds: any = [];
		if (this.medArray.length > 0) {
			for (let i = 0; i < this.medArray.length; i++) {
				if (this.medArray[i]["addedBy"] == undefined || this.medArray[i]["addedBy"] == null) {
					this.medArray[i]["addedBy"] = this.getUserName();
				}
				if (this.medArray[i]["isSaved"]) {
					if (this.getDateStringFromDateYMD(this.medArray[i]["medDate"]) != this.medArrayTemp[i]["medDate"] || this.medArray[i]["name"] != this.medArrayTemp[i]["name"] || this.medArray[i]["qty"] != this.medArrayTemp[i]["qty"] || this.medArray[i]["morning"] != this.medArrayTemp[i]["morning"] || this.medArray[i]["afternoon"] != this.medArrayTemp[i]["afternoon"] || this.medArray[i]["evening"] != this.medArrayTemp[i]["evening"] || this.medArray[i]["sos"] != this.medArrayTemp[i]["sos"] || this.medArray[i]["noOfDays"] != this.medArrayTemp[i]["noOfDays"] || this.medArray[i]["notes"] != this.medArrayTemp[i]["notes"] /* || this.medArray[i]["status"] != this.medArrayTemp[i]["status"] */) {
						this.medArray[i]["updatedBy"] = this.getUserName();
					}
				}
				finalMeds.push({
					addedBy: this.medArray[i]["addedBy"],
					updatedBy: this.medArray[i]["updatedBy"],
					name: this.medArray[i]["name"],
					qty: this.medArray[i]["qty"],
					meals: this.medArray[i]["meals"],
					noOfDays: this.medArray[i]["noOfDays"],
					status: this.medArray[i]["status"],
					notes: this.medArray[i]["notes"],
					morning: this.medArray[i]["morning"],
					afternoon: this.medArray[i]["afternoon"],
					evening: this.medArray[i]["evening"],
					sos: this.medArray[i]["sos"],
					medDate: this.getDateStringFromDateYMD(this.medArray[i]["medDate"]),
				})
			}
		}
		try {
			for (let i = 0; i < finalMeds.length; i++) {
				delete finalMeds[i].isSaved;
				delete finalMeds[i].isCheckedForMail;
				delete finalMeds[i].showCheckboxForMail;
			}
		} catch (error) { }
		this.saveMedLoader = true;
		this.apiService.addCaseMeds({ id: this.uId, meds: JSON.stringify(finalMeds) }).subscribe({
			next: data => {
				this.toastr.success("Saved successfully.", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.saveMedLoader = false;
				this.getCaseMedicines();
				this.medSection();
				this.clearPrescArray();
			}, error: (error) => {
				this.toastr.error("Something went wrong", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.saveMedLoader = false;
				this.printPrescArray = [];
			}
		});
	}

	rePrescribeMedicine(index: number) {
		let obj: any = JSON.parse(JSON.stringify(this.medArray[index]));
		if (this.medArray[index].status == "Started") {
			this.medArray[index].status = "Stopped";
		}
		obj.medDate = new Date();
		obj.status = "Started";
		this.medArray.push(obj);
		this.medArrayTemp.push(obj);
	}

	onMedInputChanged(query: string, index: number): void {
		this.medLoadingIndex = index;
		this.searchTermsMed.next(query);
	}

	/* Lab Tests */

	getCaseTests() {
		this.apiService.getLabTests({ id: this.uId, flag: "labs" }).subscribe({
			next: (data: any) => {
				try {
					this.testArray = data ? JSON.parse(JSON.stringify(data)) : [];
				} catch (error) {
					this.testArray = [];
				}
				try {
					this.testArrayTemp = data ? JSON.parse(JSON.stringify(data)) : [];
				} catch (error) {
					this.testArrayTemp = [];
				}
				for (let i = 0; i < this.testArray.length; i++) {
					try {
						this.testArray[i].date = new Date(this.testArray[i].date);
						if (this.testArray[i].date instanceof Date && !isNaN(this.testArray[i].date)) {

						} else {
							this.testArray[i].date = null;
						}
					} catch (error) {
						this.testArray[i].date = null;
					}
					this.testArray[i].isSaved = true;
					this.testArray[i].isCheckedForMail = true;
					this.testArray[i].showCheckboxForMail = true;
				}
			}, error: (error) => {
				this.testArray = [];
				this.testArrayTemp = [];
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	testSection() {
		this.showTestHistory = !this.showTestHistory;
		this.printTestArray = [];
	}

	caseTestPdfHistory() {
		this.apiService.caseLabTestsList({ id: this.uId, flag: "labs-prescription" }).subscribe({
			next: data => {
				this.caseTestPdfList = data;
			}, error: (error) => {
				this.caseTestPdfList = [];
			}
		});
	}

	copyTestsToClipBoard(num: number) {
		var tableId = "testsTempTableToCopy" + num;
		let tblStr = '<ul id="' + tableId + '">';
		for (let i = 0; i < this.testArray.length; i++) {
			tblStr += '<li>';
			tblStr += this.testArray[i].date ? this.getDateStringFromDateDMY(new Date(this.testArray[i].date)) : "";
			tblStr += ' - ';
			tblStr += this.testArray[i].name;
			tblStr += this.testArray[i].notes ? ' - ' + this.testArray[i].notes : "";
			tblStr += '</li>';
		}
		tblStr += '</ul>';
		$("#testTempTableContainerForCopy" + num).html(tblStr);
		this.selectElementContents(tableId);
		$("#testTempTableContainerForCopy" + num).html("");
	}

	loadTestsPdf() {
		if (!this.testPara.prescDoctor) {
			this.toastr.error("Please select doctor.", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		let address = '';
		let mobOrEmail = '';
		let cand_dob: any = "";
		if (this.caseDetails.dob) {
			try {
				let curDate = new Date();
				let candDOB = new Date(this.caseDetails.dob.split("-").reverse().join("/"));
				let candDOBYear = candDOB.getFullYear();
				let curYear = curDate.getFullYear();
				cand_dob = curYear - candDOBYear;
			} catch (error) {
				cand_dob = "";
			}
		}
		if (this.testPara.prescUserType == 'Candidate') {
			address = this.caseDetails.address || '-';
			mobOrEmail = this.caseDetails.email || this.caseDetails.tel_no || "-";
		} else {
			address = this.caseDetails.vessel || '-';
			mobOrEmail = this.caseDetails.vessel || "-";
		}
		let prescDetails: any = {};
		prescDetails.candName = this.caseDetails.f_name + " " + this.caseDetails.l_name;
		prescDetails.caseId = this.caseDetails.case_id;
		prescDetails.id = this.uId;
		prescDetails.gender = this.caseDetails.gender;
		prescDetails.prescribeBy = this.testPara.prescDoctor ? this.testPara.prescDoctor.name : "";
		prescDetails.address = address;
		prescDetails.mobOrEmail = mobOrEmail;
		prescDetails.chief_complaint = this.testPara.chief_complaint;
		prescDetails.cand_dob = cand_dob.toString();
		prescDetails.doctor = this.testPara.prescDoctor ? this.testPara.prescDoctor.id : null;
		let finalTests: any = [];
		if (this.printTestArray.length > 0) {
			for (let i = 0; i < this.printTestArray.length; i++) {
				finalTests.push({
					name: this.printTestArray[i]["name"],
					notes: this.printTestArray[i]["notes"] || "",
					date: this.getDateStringFromDateDMY(this.printTestArray[i]["date"]),
				})
			}
		}
		prescDetails.prescArr = finalTests;
		this.testPdfLoader = true;
		this.apiService.getLabTestsPdf(prescDetails).subscribe({
			next: (data: any) => {
				let pdfData: any = data["body"];
				const blob = new Blob([pdfData], { type: 'application/pdf' });
				var today = new Date();
				var day = today.getDate() + "";
				var month = (today.getMonth() + 1) + "";
				var year = today.getFullYear() + "";
				var hour = today.getHours() + "";
				var minutes = today.getMinutes() + "";
				var seconds = today.getSeconds() + "";

				day = this.checkZero(day);
				month = this.checkZero(month);
				hour = this.checkZero(hour);
				minutes = this.checkZero(minutes);
				seconds = this.checkZero(seconds);
				let fileName = day + "-" + month + "-" + year;
				FileSaver.saveAs(blob, "Tests_" + fileName + "_" + this.caseDetails.case_id + ".pdf");
				this.testPdfLoader = false;
				this.clearTestArray();
				this.caseTestPdfHistory();
			}, error: (error) => {
				this.toastr.error("Unable to generate pdf.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.testPdfLoader = false;
			}
		});
	}

	clearTestArray() {
		this.printTestArray = [];
		this.testPara.chief_complaint = null;
		this.testPara.prescDoctor = null;
		this.testPara.prescUserType = "Candidate";
		this.testArray.forEach((val, key) => {
			setTimeout(() => {
				val.isChecked = false;
			}, 100);
		})
	}

	checkTest(data: any) {
		if (data.isChecked) {
			this.printTestArray.push(data);
		} else {
			this.printTestArray.forEach((val: any, key: any) => {
				if (val.name === data.name) {
					this.printTestArray.splice(key, 1);
				}
			})
		}
	}

	removeTest(index: any) {
		this.testArray.splice(index, 1);
		this.testArrayTemp.splice(index, 1);
	}

	AddNewTest() {
		this.testArray.push(this.getNewTestAttr());
		this.testArrayTemp.push(this.getNewTestAttr());
	}

	getNewTestAttr() {
		return { name: null, date: new Date() };
	}

	saveTests() {
		for (let i = 0; i < this.testArray.length; i++) {
			let val = this.testArray[i];
			if (!val.name || !val.date) {
				this.toastr.error("Required Fields", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				return;
			}
		}
		let finalTests: any = [];
		if (this.testArray.length > 0) {
			for (let i = 0; i < this.testArray.length; i++) {
				if (this.testArray[i]["addedBy"] == undefined || this.testArray[i]["addedBy"] == null) {
					this.testArray[i]["addedBy"] = this.getUserName();
				}
				if (this.testArray[i]["isSaved"]) {
					if (this.getDateStringFromDateYMD(this.testArray[i]["date"]) != this.testArrayTemp[i]["date"] || this.testArray[i]["name"] != this.testArrayTemp[i]["name"] || this.testArray[i]["notes"] != this.testArrayTemp[i]["notes"]) {
						this.testArray[i]["updatedBy"] = this.getUserName();
					}
				}
				finalTests.push({
					addedBy: this.testArray[i]["addedBy"],
					updatedBy: this.testArray[i]["updatedBy"],
					name: this.testArray[i]["name"],
					notes: this.testArray[i]["notes"],
					date: this.getDateStringFromDateYMD(this.testArray[i]["date"]),
				})
			}
		}
		try {
			for (let i = 0; i < finalTests.length; i++) {
				delete finalTests[i].isSaved;
				delete finalTests[i].isCheckedForMail;
				delete finalTests[i].showCheckboxForMail;
			}
		} catch (error) { }
		this.saveTestLoader = true;
		this.apiService.addCaseMeds({ id: this.uId, labs: JSON.stringify(finalTests) }).subscribe({
			next: data => {
				this.toastr.success("Saved successfully.", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.saveTestLoader = false;
				this.getCaseTests();
				this.testSection();
				this.clearTestArray();
			}, error: (error) => {
				this.toastr.error("Something went wrong", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.saveTestLoader = false;
				this.printTestArray = [];
			}
		});
	}

	rePrescribeTest(index: number) {
		let obj: any = JSON.parse(JSON.stringify(this.testArray[index]));
		obj.date = new Date();
		this.testArray.push(obj);
		this.testArrayTemp.push(obj);
	}

	onTestInputChanged(query: string, index: number): void {
		this.testLoadingIndex = index;
		this.searchTermsTest.next(query);
	}
}
